import __ from "src/utils/Translations";
// eslint-disable-next-line import/prefer-default-export
export const getAhrBaseBreadcrumbs = (companyName) => [
  { title: `${__("Zarządzanie firmą")} ${companyName}`, link: "/ahr}" },
];
